import React, { useState } from 'react';
import { CheckSquareIcon, SquareIcon } from 'lucide-react';
interface InteractiveChecklistItemProps {
  children: React.ReactNode;
  onToggle: (checked: boolean) => void;
}
export function InteractiveChecklistItem({
  children,
  onToggle
}: InteractiveChecklistItemProps) {
  const [checked, setChecked] = useState(false);
  const handleToggle = () => {
    const newCheckedState = !checked;
    setChecked(newCheckedState);
    onToggle(newCheckedState);
  };
  return <div className={`flex items-start mb-3 p-3 rounded-md transition-colors cursor-pointer ${checked ? 'bg-blue-50 border border-blue-200' : 'bg-gray-50 hover:bg-gray-100'}`} onClick={handleToggle} data-id="element-250">
      <div className="flex-shrink-0 mr-3 mt-0.5" data-id="element-251">
        {checked ? <CheckSquareIcon className="h-5 w-5 text-blue-600" data-id="element-252" /> : <SquareIcon className="h-5 w-5 text-gray-400" data-id="element-253" />}
      </div>
      <span className={`text-sm ${checked ? 'font-medium' : ''}`} data-id="element-254">
        {children}
      </span>
    </div>;
}